import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL || 'https://localhost:7118/api';

const api = axios.create({
  baseURL,
  withCredentials: true,
});

export default api;